import { render, staticRenderFns } from "./6-1.vue?vue&type=template&id=b35c75f2&scoped=true&"
import script from "./6-1.vue?vue&type=script&lang=js&"
export * from "./6-1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b35c75f2",
  null
  
)

export default component.exports